import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  RoomsFilterContainer,
  RoomsFilterItem,
  RoomsFilterItemText
} from './styled';
import { animateHorizontalScroll } from '../../../../../utils/helpers/common';

interface ResidenceRoomsFilterProps {
  itemsRooms: number[];
  currentValue: string | number;
  stat: string;
  onClick: (value: number | string) => void;
}

const ALL_FILTER_VALUE = 'all';

export const ResidenceRoomsFilter: React.FC<ResidenceRoomsFilterProps> = ({
  itemsRooms,
  currentValue,
  stat,
  onClick
}) => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement | null>(null);

  const handleItemClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (!containerRef.current) return;
    const activeElement = e.currentTarget;

    const container = containerRef.current;
    const scrollTo =
      activeElement.offsetLeft -
      container.offsetWidth / 2 +
      activeElement.offsetWidth / 2;

    animateHorizontalScroll(container, scrollTo, 300);
  };

  const filterValues = [ALL_FILTER_VALUE, ...(itemsRooms || [])];

  return (
    <RoomsFilterContainer ref={containerRef} data-cy="residence-rooms-filter">
      {filterValues?.map(item => {
        const filterText =
          item === ALL_FILTER_VALUE
            ? t('common.all')
            : t('pages.residence.rooms_count', { count: item });

        return (
          <RoomsFilterItem
            key={item}
            data-cy="residence-filter-btn"
            data-stat={stat}
            onClick={e => {
              handleItemClick(e);
              onClick(item);
            }}
          >
            <RoomsFilterItemText $isActive={item === currentValue}>
              {filterText}
            </RoomsFilterItemText>
          </RoomsFilterItem>
        );
      })}
    </RoomsFilterContainer>
  );
};
